export default "__VITE_ASSET__BHPoJWem__"